import { useEffect, useState } from 'react';
import { events, type EventDto } from '../net/api';
import { Sheet } from './Sheet';

const day = (iso: string) => new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'long' });

export function NoticeBoard({ onClose, onShop }: { onClose: () => void; onShop: (key: string) => void }) {
  const [list, setList] = useState<EventDto[]>();
  useEffect(() => {
    events.list().then((r) => setList(r.events), () => setList([]));
  }, []);
  return (
    <Sheet title="Notice Board" subtitle="What's happening in Buddy Bay" onClose={onClose}>
      {list?.length === 0 && <p className="muted">Nothing pinned right now. Check back soon!</p>}
      {list?.map((e) => (
        <article key={e.key} className={e.live ? 'notice live' : 'notice'}>
          <span className="tag">{e.live ? `On now · until ${day(e.endsAt)}` : `Starts ${day(e.startsAt)}`}</span>
          <h3 className="mini-head">{e.name}</h3>
          <p>{e.description}</p>
          {e.shopKey && <button className="btn" onClick={() => onShop(e.shopKey!)}>Visit the festival shop</button>}
        </article>
      ))}
    </Sheet>
  );
}
